export const processConfiguration = {
  name: "Name",
  defaultValue: "Default value",
  type: "Type",
  image: "Image",
  changeImage: "Change image",
  deleteImage: "Delete image",
  description: "Description",
  flowTypes: {
    PROCESS_ENGINE: "Automation",
    CSV_IMPORTER: "Import",
    CUSTOMIZING: "Customization",
    STANDARD: "Standard"
  }
};
